
import { paperCheckAction } from "@mobile-dev/platform/common/redux/actions/PaperCheckAction";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { getApplicationFlow } from "../../../../../Utils/Utility";
import PaperCheckPayment from "./PaperCheckPayment";
import { injectIntl } from 'react-intl';

function UsBank({ intl}) {

    const dispatch = useDispatch();
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const transaction = useSelector(state => state.paperCheckPayment);
    const location = useLocation();
    let [error, setError] = useState(false)
    let [paperCheck, setpaperCheck] = useState("")
    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;
    const remainingAmount = location.state.remainingAmount;
    const bankName = location.state.bankName;
    const id = location.state.id;
    const selection = location.state.selection;
    const total_bill_amount = location.state.total_bill_amount;
    const paymentmethods=location.state.paymentmethods;
    const { formatMessage } = intl;

    function handleSubmit(paymentData) {

        if ((userData?.phone_number || getApplicationFlow() === 'Carrier')) {
            const data = {
                check_type: bankName,
                load_id: id,
                money_code: paymentData.val1,
                acct_num: paymentData.identificationNumber
            }

            dispatch(paperCheckAction(data));
        }

    }

    return (
        <React.Fragment>
            <PaperCheckPayment
                id={id}
                loading={transaction.loading}
                onSubmitClick={handleSubmit}
                length={6}
                error={transaction.error?.message}
                transactionId={transaction?.transactionStatus}
                title={formatMessage({ id: "app.us_bank_payment" })}
                paymentCodeName={formatMessage({ id: "app.money_code" })}
                amount={amount}
                originalAmount={originalAmount}
                remainingAmount={remainingAmount}
                selection={selection}
                paymentType={AppConstatnt.CHECK_PAY}
                message={formatMessage({ id: "app.go_to_home_page" })}
                identificationAttribute={formatMessage({ id: "app.transaction_Code" })}
                total_bill_amount={total_bill_amount}
                paymentmethods={paymentmethods}
            />
        </React.Fragment>
    )


}

export default injectIntl(UsBank);